import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  Select,
  MenuItem,
  TextField,
  Calendar,
  DateUtils,
} from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import { DATE_FORMAT_2 } from 'constants';
import useIntl from 'useIntl';
import mes from './intl';
import '../../ActorsFiltersPopup.scss';

export const DATE_RANGES = [
  'custom',
  'today',
  'yesterday',
  'lastWeek',
  'lastMonth',
  'previousMonth',
];

function DateRange({ from, to, errors, onChange }) {
  const t = useIntl();
  const [rangeType, setRangeType] = useState('custom');
  const todayDate = DateUtils.unixtime();

  const handleChangeDate = ({ id, value }) => {
    setRangeType('custom');
    const fDate = id === 'from' ? 'startOf' : 'endOf';
    const date = DateUtils[fDate](value.startDate * 1000, 'day');
    const unix = DateUtils.dateToUnixtime(date);
    onChange({ [id]: unix });
  };

  const handleChangeRange = (value) => {
    const dateRange = AppUtils.getRangeDate(value);
    setRangeType(value);
    onChange(dateRange);
  };

  return (
    <div styleName="filters__popup__content__section">
      <div styleName="filters__popup__content__row range">
        <div styleName="filters__popup__content__item">
          <Label value={t(mes.actorDateRangePeriod)} />
          <Select
            id="rangeType"
            styleName="filters__popup__content__select openUp"
            size="medium"
            bordered={true}
            value={rangeType}
            onChange={({ value }) => handleChangeRange(value)}
          >
            {DATE_RANGES.map((item) => (
              <MenuItem
                key={item}
                value={item}
                label={t(mes[`range_${item}`])}
              />
            ))}
          </Select>
        </div>
        <div styleName="filters__popup__content__item">
          <Label value={t(mes.from)} />
          <TextField
            styleName="filters__popup__content__textfield"
            size="medium"
            bordered={true}
            value={from ? DateUtils.toDate(from, DATE_FORMAT_2) : ''}
            error={!!errors.to}
            calendar={() => (
              <Calendar
                id="from"
                styleName="filters__popup__content__calendar"
                size="small"
                value={{ startDate: from }}
                onChange={handleChangeDate}
                maxDate={todayDate}
              />
            )}
          />
        </div>
        <div styleName="filters__popup__content__item">
          <Label value={t(mes.to)} />
          <TextField
            styleName="filters__popup__content__textfield"
            size="medium"
            bordered={true}
            value={to ? DateUtils.toDate(to, DATE_FORMAT_2) : ''}
            error={!!errors.to}
            helperText={t(mes[errors.to])}
            calendar={() => (
              <Calendar
                id="to"
                styleName="filters__popup__content__calendar dateTo"
                size="small"
                value={{ startDate: to }}
                onChange={handleChangeDate}
                maxDate={todayDate}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}

DateRange.propTypes = {
  from: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errors: PropTypes.object,
  onChange: PropTypes.func,
};

export default DateRange;
